import { Box, Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { formatTime } from "src/coach/service/coach.utils";
import { EventService } from "src/event/service/event.service";

export default function ClassCard({ eventDates }) {
  return (
    <Box>
      {eventDates.map((eventDate, index) => {
        const isFirst = index === 0;
        const isLast = index === eventDates.length - 1;

        return (
          <Box
            key={index}
            className={`tw-border tw-border-gray tw-p-4 t ${
              isFirst && isLast
                ? "tw-rounded-md tw-mb-6" // Single card: full border radius
                : isFirst
                ? "tw-rounded-t-md tw-border-b-0" // First card: rounded top, no bottom border
                : isLast
                ? "tw-rounded-b-md tw-mb-6" // Last card: rounded bottom
                : "tw-border-b-0" // Middle cards: no bottom border
            }`}
          >
            <div className="tw-flex tw-justify-between tw-items-center">
              <Box>
                <span
                  className="tw-text-[14px] tw-font-bold tw-text-black tw-mb-1"
                >
                  {EventService.effectiveName(eventDate?.event)}{" "}
                  <span className="tw-font-normal tw-text-sm">
                    ({EventService.ageRangeLabel(eventDate?.event)})
                  </span>
                </span>

                <Typography
                  variant="body2"
                  className="tw-text-gray-600 tw-text-sm"
                >
                  <span>
                    {format(
                      new Date(eventDate?.startDateTimeInUTC),
                      "EEEE"
                    )},
                  </span>
                  
                   <span>
                    {' '}{formatTime(eventDate?.event.startTime)} - {formatTime(eventDate?.event.endTime)}
                   </span>
                  <span>
                    {EventService.dateLimits(eventDate?.event) ? ` (${EventService.dateLimits(eventDate?.event)})` : null}
                  </span>
                </Typography>
              </Box>
            </div>
          </Box>
        );
      })}
    </Box>
  );
}
